<template>
  <div class="contact">
    <Menu></Menu>
    <div class="container">
      <div class="map1">
        <div class="aboutMap">
          <div class="map-c">
            <div class="map-l">
              <baidu-map id="allmap" @ready="mapReady"> </baidu-map>
            </div>
            <div class="map-r">
              <div class="r-center">
                <div>
                <i class="fontImg icon-tel"></i>
                 <span>{{companyInfo.phone}}</span>
              </div>
              <div>
                <i class="fontImg icon-add"></i>
                <span>{{ companyInfo.address }}</span>
              </div>
              <div>
                <i class="fontImg icon-email"></i>
                <span>{{ companyInfo.email }}</span>
              </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <!-- <div class="bottom-t">
              <div class="one">
                <i
                  class="iconfont"
                  :class="type == 3 ? 'height' : ''"
                  @click="setWay(3)"
                  >&#xe600;</i
                >
                <div>公交</div>
              </div>
              <div class="two">
                <i
                  class="iconfont"
                  :class="type == 1 ? 'height' : ''"
                  @click="setWay(1)"
                  >&#xe67a;</i
                >
                <div>驾车</div>
              </div>
              <div class="three">
                <i
                  class="iconfont"
                  :class="type == 2 ? 'height' : ''"
                  @click="setWay(2)"
                  >&#xe74a;</i
                >
                <div>步行</div>
              </div>
            </div> -->
            <div class="bottom-b">
              <div class="start">
                <input
                  type="text"
                  v-model="search.start"
                  :disabled="isChanged"
                />
              </div>
              <div class="center">
                <i class="iconfont" @click="toggle">&#xe608;</i>
              </div>
              <div class="end">
                <input
                  type="text"
                  v-model="search.end"
                  :disabled="!isChanged"
                />
              </div>
              <div class="search">
                <el-button type="primary" size="small" @click="searchSite"
                  >搜索</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="contactUs">
        <div class="contactBox">
          <div class="box">
             <div class="box-t">
               <div class="box-l">
               <div class="name">
              <input type="text" v-model="formData.name" placeholder="姓名" />
            </div>
            <div class="type">
              <input type="text" v-model="formData.phone" placeholder="联系方式" />
            </div>
            <div class="email">
              <input type="text" v-model="formData.email" placeholder="邮箱" />
            </div>
             </div>
            <div class="box-r">
              <div class="remark">
              <textarea v-model="formData.text" placeholder="请在此输入留言内容 ，我们会尽快与你联系。"></textarea>
            </div>
            </div>
             </div>
            <el-button class="upload" @click="uploadInfo" type="primary"
              >点击提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfo ,sendInfoToCompany} from "@/api/manage";
import Menu from "../../components/menu/menu.vue";
export default {
  components: { Menu },
  data() {
    return {
      active: false,
      type: 3, //查询路线类型，1.驾车  2.步行 3.公交
      tabberData: [
        { id: "1", name: "公司新闻" },
        { id: "2", name: "行业动态" },
      ],
      activeIndex: "1",
      tabTitle: "新闻中心",
      point: "",
      search: {
        start: "", //起点地名，仅限武汉的，如输入'武汉大学'
        end: "湖北有所依科技有限公司",
      },
      isChanged: false, //true：终点与起点互换，false：起点与终点未互换
      siteZB: {}, //查询目的地的经纬度，x，y
      companyInfo: "",
      formData:{
          phone:'',
          email:'',
          text:'',
          name:''
      }
    };
  },
  watch: {
    $route(to, form) {
      this.activeIndex = to.params.id;
      window.scrollTo(0, 0);
    },
  },
  async created() {
    let res = await getCompanyInfo();
    console.log('获取新闻5');
    this.companyInfo = res.data;
  },
  mounted(){
   window.scrollTo(0, 0);
  },
  methods: {
    changeTabber(index) {
      this.$router.push({ name: "contact", params: { id: index } });
    },
    setWay(type){
      this.type = type
      if(!this.isChanged&&this.search.start!==''){//有搜索内容且点击了乘车方式
        this.searchSite()
      }else if(this.isChanged&&this.search.end!==''){
        this.searchSite()
      }
    },
    mapReady({ BMap, map }) {
      // 选择一个经纬度作为中心点
      // this.point = new BMap.Point(111.189377,30.482625); //公司的地址 
      this.point = new BMap.Point(114.42896560722743,30.472645141765945); //公司的地址 
      map.centerAndZoom(this.point, 18);
      var marker = new BMap.Marker(this.point); // 创建标注
      map.addOverlay(marker);

      var opts = {
        width: 400,
        higth: 70,
        // title: "龙舟坪镇龙舟大道223号",
        title: "光谷鼎创国际",
      };
      var infoWindow = new BMap.InfoWindow(
        // "地址：湖北省宜昌市长阳土家族自治县龙舟坪镇龙舟大道223号（宁馨苑） B2 202",
        "地址：湖北省武汉市洪山区光谷大道光谷鼎创国际4栋1018",
        opts
      );
      map.openInfoWindow(infoWindow, this.point);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var scaleCtrl = new BMap.ScaleControl(); // 添加比例尺控件
      map.addControl(scaleCtrl);
    },
    toggle() {
      this.isChanged = !this.isChanged;
      let flag = JSON.parse(JSON.stringify(this.search.end));
      this.search.end = JSON.parse(JSON.stringify(this.search.start));
      this.search.start = flag;
      if(this.search.start!==''&&this.search.end!==''){//如果起始点都有数据，点击交换则触发搜索事件
        this.searchSite()
      }
      //   var map = new BMap.Map("allmap")
      // 将地址解析结果显示在地图上，并调整地图视野
    },
    searchSite() {
      let self = this;
      var myGeo = new BMap.Geocoder();
      var map = new BMap.Map("allmap");
      let searchText = this.isChanged ? this.search.end : this.search.start;
      // var driving = new BMap.DrivingRoute(map, {
      //   //new一个驾车路线
      //   renderOptions: { map: map, autoViewport: true },
      // });
      // var walking = new BMap.WalkingRoute(map, {
      //   //new一个步行路线
      //   renderOptions: { map: map, autoViewport: true },
      // });

      var transit = new BMap.TransitRoute(map, {
        //new一个公交路线
        renderOptions: { map: map },
        onSearchComplete: function (results) {
          if (transit.getStatus() != BMAP_STATUS_SUCCESS) {
            return;
          }
        },
      });
      myGeo.getPoint(
        searchText, //地名，仅限武汉的，
        function (point) {
          self.siteZB.x = point.lng; //获取经度
          self.siteZB.y = point.lat; //获取维度
         // console.log("self.siteZB", self.siteZB);
          var p1, p2;
          if (!self.isChanged) {
            //如果起点与终点位置互换，则对应的经纬度也应该互换
            p1 = new BMap.Point(self.siteZB.x, self.siteZB.y);
            // p2 = new BMap.Point(111.189377,30.482625);
            p2 = new BMap.Point(114.42896560722743,30.472645141765945);
            
          } else {
            p2 = new BMap.Point(self.siteZB.x, self.siteZB.y);
            // p1 = new BMap.Point(111.189377,30.482625);
            p1 = new BMap.Point(114.42896560722743,30.472645141765945);
          }
          // if (self.type == 1) {
          //   driving.search(p1, p2);
          // } else if (self.type == 2) {
          //   walking.search(p1, p2);
          // } else 
          if (self.type == 3) {
            transit.search(p1, p2);
          }
        },
        "武汉市"
      );
       map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    },
    async uploadInfo(){
        let telReg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
        let emailReg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/ 
        if(!telReg.test(this.formData.phone)){
          return this.$message.error('请输入正确的手机号！')
        }else if (!emailReg.test(this.formData.email)){
            return this.$message.error('请输入正确的邮箱！')
        }else if (this.formData.name==''){
            return this.$message.error('请输入姓名！')
        } else if (this.formData.text==''){
          return this.$message.error('请输入留言内容！')
        }else{
            
            let res = await sendInfoToCompany(this.formData)
            if(res.code==200){
                this.$message.success('提交成功！')
            for(let k in this.formData){
                this.formData[k]=''
            }
            }
        }
    },
    
  },
};
</script>
<style lang="less" scoped>
.map1 {
  margin: 40px auto;
  width: 1200px;
}
.map {
  width: 100%;
  height: 300px;
}
.contactUs {
  width: 1200px;
  height: 382px;
  // background-image: url("../../styles/images/banner/lianxi_pic2.png");
  background-size: 100% 100%;
  margin: 0 auto 20px;
  position: relative;
}
.contactBox {
  width: 860px;
  height: 288px;
  position: absolute;
  top: 47px;
  left: 170px;
  box-sizing: border-box;
}
.box-t{
  display: flex;
  justify-content: space-between;
}
.fontImg{
  width: 28px;
  height: 28px;
}
.contactBox .box {
  width: 860px;
  height:288px;
  overflow: hidden;
  .name,
  .type{
    height: 51px!important
  }
  .email{
    height: 50px!important
  }
  .name,
  .type,
  .email,
  .remark {
    width: 400px;
    margin-bottom: 28px;
    box-sizing: border-box;
    border: 2px solid #ccc;
    padding-left: 12px;
  }
  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #ccc;
  }
  .type {
    height: 60px;
  }
  .email {
    height: 65px;
  }
  .remark {
    height: 207px;
    padding-top: 13px;
  }
  .upload {
    width: 121px;
    height: 39px;
    border-radius: 0;
    margin: 13px auto;
    display: block;
  }
  input,
  textarea {
    width: 100%;
    outline: none;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    height: 100%;
    font-size: 16px;
    color: #333;
    padding-left: 12px;
  }
}
#allmap {
  height: 450px;
  width: 900px;
  border: 1px solid #ccc;
}
#allmap /deep/ .BMap_bubble_title {
  font-weight: 700;
  font-size: 16px;
}
#allmap /deep/ .BMap_bubble_content {
  font-size: 14px;
  line-height: 20px;
  margin-top: 5px;
}
.aboutMap {
  width: 1200px;
  height: 562px;
  box-shadow: 0.5px 0.866px 3px 0px rgb(0 0 0 / 14%);
}
.map-c {
  display: flex;
}
.map-r {
  height: 451px;
  width: 100%;
  box-shadow: 0.5px 0.866px 3px 0px rgb(0 0 0 / 14%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.r-center{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 100%!important;
  height: 227px;
}
.map-r h4 {
  font-size: 18px;
}
.map-r i {
  font-size: 28px;
}
.map-r div {
  width: 247px;
}
.r-center div{
  display: flex;
  align-items: center
}
.r-center div span{
  margin-left: 9px;
  width: 210px;
  font-size: 16px;
}
.bottom {
  height: 170px;
  padding-top: 10px;
}
.bottom-t {
  margin: 20px auto;
  width: 1088px;
  height: 44px;
  display: flex;
  line-height: 44px;
}
.bottom-t i {
  font-size: 22px;
  color: #ccc;
}
.bottom-t i:hover {
  cursor: pointer;
}
.one div,
.two div {
  width: 100px;
  border-bottom: 1px solid skyblue;
  text-indent: 10px;
}
.three div {
  width: 780px;
  border-bottom: 1px solid skyblue;
  text-indent: 10px;
}
.one,
.two,
.three {
  display: flex;
}
.bottom-b {
  width: 1088px;
  height: 40px;
  margin-left: 17px;

  line-height: 40px;
}
.start {
  width: 268px;
}
.bottom-b {
  display: flex;
}
.center {
  width: 80px;
  text-align: center;
}
.center:hover {
  cursor: pointer;
}
.center i {
  font-size: 24px;
}
.bottom-b input {
  width: 249px;
  padding: 10px 0;
  padding-left: 22px;
  line-height: 20px;
  height: 20px;
  text-align: left;
  border: none;
  border-bottom: 1px solid #eaebed;
  font-size: 15px;
  color: #000000;
  outline: none;
}
.start input {
  background: url("../../styles/images/start.jpg") no-repeat left center;
}
.end input {
  background: url("../../styles/images/end.jpg") no-repeat left center;
}
.search {
  margin-left: 20px;
}
.height {
  color: #409eff !important;
}
.icon-tel{
  background: url('../../styles/images/newImages/icon_phone.png') no-repeat center;
}
.icon-add{
  background: url('../../styles/images/newImages/icon_address.png') no-repeat center;
}
.icon-email{
  background: url('../../styles/images/newImages/icon_email.png') no-repeat center;
}
</style>